(() => {
  if (window.EyesnugTabletGallery) return;
  const tablet = window.matchMedia('(min-width: 750px) and (max-width: 1099px)');
  const states = new Map();

  const layout = (gallery) => {
    if (!gallery.isConnected) {
      states.get(gallery)?.observer.disconnect();
      states.get(gallery)?.mediaObserver.disconnect();
      states.delete(gallery);
      return;
    }
    if (!tablet.matches) {
      gallery.style.removeProperty('--eyesnug-tablet-grid-width');
      gallery.removeAttribute('data-tablet-columns');
      return;
    }
    const grid = gallery.querySelector('.product__media-list__container--great-five');
    const info = gallery.closest('.product__outer')?.querySelector('.product__info-wrapper');
    if (!grid || !info || !grid.children.length) return;
    const count = grid.children.length;
    const width = gallery.clientWidth;
    // The gallery is out of flow, so it cannot enlarge its own height budget.
    const height = Math.min(gallery.clientHeight, info.getBoundingClientRect().bottom - gallery.getBoundingClientRect().top) - 16;
    if (width <= 0 || height <= 0) return;
    const gap = parseFloat(getComputedStyle(grid).rowGap) || 8;
    const singleHeight = count * width + (count - 1) * gap;
    const columns = singleHeight <= height ? 1 : 2;
    // An odd count gets one full-width hero, followed by complete paired rows.
    const hero = columns === 2 ? count % 2 : 0;
    const pairs = columns === 2 ? (count - hero) / 2 : 0;
    const rows = columns === 1 ? count : hero + pairs;
    const widthUnits = columns === 1 ? count : hero + pairs / 2;
    const gapHeight = (rows - 1) * gap - pairs * gap / 2;
    const fittedWidth = Math.min(width, (height - gapHeight) / widthUnits);
    gallery.setAttribute('data-tablet-columns', String(columns));
    gallery.style.setProperty('--eyesnug-tablet-grid-width', `${Math.max(1, Math.floor(fittedWidth))}px`);
  };

  const initialize = () => {
    document.querySelectorAll('[data-responsive-product-gallery]').forEach((gallery) => {
      if (states.has(gallery)) return;
      let frame;
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => layout(gallery));
      };
      const observer = new ResizeObserver(schedule);
      const mediaObserver = new MutationObserver(schedule);
      const grid = gallery.querySelector('.product__media-list__container--great-five');
      const info = gallery.closest('.product__outer')?.querySelector('.product__info-wrapper');
      observer.observe(gallery);
      if (info) observer.observe(info);
      if (grid) mediaObserver.observe(grid, {childList: true});
      states.set(gallery, {observer, mediaObserver, schedule});
      schedule();
    });
  };
  window.EyesnugTabletGallery = {initialize};
  tablet.addEventListener('change', () => states.forEach(({schedule}) => schedule()));
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', (event) => states.forEach((state, gallery) => {
    if (!gallery.isConnected || event.target.contains(gallery)) {
      state.observer.disconnect();
      state.mediaObserver.disconnect();
      states.delete(gallery);
    }
  }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
